module.exports = __webpack_public_path__ + "img/服务案例04.815d7a65.png";